<script lang="ts">
import type { Events, ModalDataComponent } from '@components/Modals/types'

export const events: Events = null
export let data: ModalDataComponent
const { content, props } = data
</script>

<div class="modal-body">
    <svelte:component this={content} {...props} />
</div>
